import {AfterViewInit, Component, OnInit} from '@angular/core';

import {BaseService} from '../../../services/base.service';
import {AuthService} from '../../../services/auth.service';
import * as moment from 'moment';
import {SERVER_DATE_FORMAT_WITH_TIME, SERVER_DATE_FORMAT_WITHOUT_TIME} from '../../../config/date_format';
import {ActivatedRoute} from '@angular/router';
import {ReplaySubject, Subject} from 'rxjs';
import {User} from '../../../models/user';
import {TrackingLocation} from '../../../models/tracking-location';
import swal from 'sweetalert2';
import {FormControl} from '@angular/forms';
import {takeUntil} from 'rxjs/internal/operators';
import {Endpoints} from '../../../config/endpoints';

@Component({
    selector: 'app-user-location-list',
    templateUrl: './user-location-list.component.html',
    styleUrls: ['./user-location-list.component.scss']
})
export class UserLocationListComponent implements OnInit {

    lat = 0.0;
    lng = 0.0;

    loggedUser: User;
    users: User[] = [];
    filteredUsers: ReplaySubject<User[]> = new ReplaySubject<User[]>(1);
    userFilter: FormControl = new FormControl();
    locationList: TrackingLocation[] = [];
    loadingData = false;

    filters = {
        'UserId': null,
        'Date': moment().format(SERVER_DATE_FORMAT_WITHOUT_TIME)
    };

    private _unsubscribeAll: Subject<any>;

    constructor(private route: ActivatedRoute, private service: BaseService) {
        this._unsubscribeAll = new Subject();

    }

    ngOnInit(): void {
        this._getUsers();
        this.userFilter.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (!this.users) {
                return;
            }

            const search = this.userFilter.value;
            if (!search) {
                this.filteredUsers.next(this.users.slice());
                return;
            }
            this._getUsers(search);
            this.filteredUsers.next(this.users.filter(user => user.UserName.toLowerCase().indexOf(search.toLowerCase()) > -1));
        });
    }

    setDateRange(event): void {
        const eventDate = moment(event.value);
        eventDate.set('hour', 23);
        eventDate.set('minute', 59);
        eventDate.set('second', 59);

        this.filters.Date = moment(eventDate).format(SERVER_DATE_FORMAT_WITHOUT_TIME);
    }


    _getUsers(search?: string): void {

        this.service.getUserList({
            ResponseSize: 'MINIFY',
            Active: true,
            PageNumber: 0,
            RecordsPerPage: 50,
            SearchKey: search,
            UserId: this.filters.UserId
        }).subscribe(pCustomers => {
            this.users = pCustomers;
            this.filteredUsers.next(this.users.slice());
        });
    }

    getLocationList(): void {
        if (!this.filters.UserId) {
            swal('Error!', 'Please select a user', 'error');
            return;
        }

        this.loadingData = true;
        this.service.getUserLocationList(this.filters).subscribe(locationList => {
            this.loadingData = false;
            if (locationList.length > 0) {
                this.lat = locationList[0].Latitude;
                this.lng = locationList[0].Longitude;
            }

            this.locationList = locationList;
        }, error => {
            this.loadingData = false;
        });
    }

}
